module.exports = __webpack_public_path__ + "static/media/production_comparative_per_wtg.c796a056.svg";